import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { service_controllers_methods } from './service_controllers_methods';
import { ActiveInactiveFor, KeyValues3, Wrapper3, Languages, LocalService, StatusWithId, DisplaySection, Wrappers3, Paging, GeneralConfigType, KeyValues5, KeyValueSet, LanguageKeyType, Status, Wrapper5, KeyValueSets, PageKey, FocusInputType } from './local.service';
import { HttpRequestComponent } from '../app/shared/http-request/http-request.component';

@Injectable({
  providedIn: 'root'
})
export class LanguageManagementService {
  private controllerName = service_controllers_methods.language.controller;
  private methods = service_controllers_methods.language.methods;

  constructor(private localService: LocalService, private router: Router, private httpService: HttpRequestComponent) { }

  public onLoad() {
    this.getLanguagesToDisplay().subscribe(result => {
      this.localService.languages = result.val;
      this.localService.languagesEquivalent = result.valEqu;
      this.localService.languageContent = {};
      document.getElementsByTagName('style')[0].innerHTML = result.styles;
      if (this.localService.isDirectUrlWithLogin() || !this.localService.isDirectUrl()) {
        result.languageContentsJson.content.forEach(x => {
          this.localService.languageContent[x.key] = JSON.parse(x.value);
        });
      }
      if (this.localService.languages.filter(x => x.key == this.localService.selected.applicationLanguage).length == 0) {
        var selectedLanguage = this.localService.languages.find(x => x.v1 == this.localService.selectedLanguageCode);
        this.localService.selectedLanguageCode = selectedLanguage.v1;
        this.localService.selected.applicationLanguage = selectedLanguage.key;
      } else {
        let item = this.localService.languages.filter(x => x.key == this.localService.selected.applicationLanguage)[0];
        this.localService.selectedLanguageCode = item.v1;
        this.localService.selected.applicationLanguage = item.key;
      }

      this.onLanguagedChangedElementRefresh();
      this.onCheckLogin();
      this.localService.checkBrowser();
      if (!this.localService.getLastUser().key && !this.localService.getLastLanguageSelecetd()) {
        this.localService.onFocusNextInput('btn_change_language', FocusInputType.Button, true);
      } else if (this.localService.redirectUrl && this.localService.redirectUrl.startsWith(this.localService.barCodePrefix)) {
        this.localService.onFocusNextInput('btn_login_logout', FocusInputType.Button, true);
      }
    });
  }

  public onCheckLogin() {
    if (this.localService.isDirectUrl()) {
      this.localService.setBasicParamsFromUrl();
      this.localService.setDirectUrlSelected();
      this.getMemberApplicationLanguageIdByMemberId(this.localService.selected.user, this.localService.selected.countryCode).subscribe(result => {
        if (result && result.status == Status.Success) {
          this.localService.selected.applicationLanguage = result.id;
          let item = this.localService.languages.filter(x => x.key == this.localService.selected.applicationLanguage)[0];
          this.localService.selectedLanguageCode = item.v1;
          this.onForceAfterLoad();
        }
      });
    }
    if (this.localService.directUrlWithoutLogin.filter(x => window.location.href.indexOf(x) > -1).length > 0) {
      //this.localService.redirectUrl = window.location.href;
      if (window.location.href.indexOf('/guide') > -1) {
        this.localService.navigateToPage = PageKey.Guide;
      } else if (window.location.href.indexOf('/pricing-calculator') > -1) {
        this.localService.navigateToPage = PageKey.PricingCalculator;
      } else if (window.location.href.indexOf('/lang/') > -1) {
        this.localService.navigateToPage = PageKey.LoginWithLanguage;
      } else if (this.localService.redirectUrl) {
        this.router.navigate([this.localService.redirectUrl]);
      } else {
        this.localService.redirectUrl = window.location.href;
      }
    } else
      if (this.localService.selected.user == '' && !this.localService.isDirectUrl())
        this.router.navigate(['/']);

    this.localService.onAutoLogin();
  }

  public getEnglishLanguageId() {
    var item = this.localService.languages ? this.localService.languages.find(x => x.v1 == 'en') : null;
    return item ? item.key : '';
  }

  onLanguageChanged() {
    let language = this.localService.languages.find(x => x.key == this.localService.selected.applicationLanguage);
    this.localService.selectedLanguageCode = language ? language.v1 : 'en';
    let lstKeys: any = [];
    if (this.localService.languageContent != null) {
      for (var key in this.localService.languageContent)
        lstKeys.push(key);
    }
    if (lstKeys.length == 0) {
      lstKeys.push("common");
    }
    this.localService.languageContent = null;
    this.getLanguageContentToDisplayBySection(lstKeys).subscribe(result => {
      this.localService.languageContent = {};
      result.content.forEach(x => {
        this.localService.languageContent[x.key] = JSON.parse(x.value);
      });
      setTimeout(() => { this.onLanguagedChangedElementRefresh() }, 100);
    });
  }

  onLanguagedChangedElementRefresh() {
    let elements = document.getElementsByClassName('on_language_changed');
    if (elements != undefined && elements != null) {
      for (var i = 0; i < elements.length; i++) {
        let element = elements[i] as HTMLElement;
        element.click();
      }
    }
  }

  onForceAfterLoad() {
    setTimeout(() => {
      let elements = document.getElementsByClassName('force_click_after_load');
      if (elements != undefined && elements != null) {
        for (var i = 0; i < elements.length; i++) {
          let element = elements[i] as HTMLElement;
          element.click();
        }
      }
    }, 10);
  }

  public ensureLanguageSectionKeys(lstKeys: string[]) {
    if (this.localService.selected && this.localService.selected.applicationLanguage != '') {
      if (this.localService.languageContent) {
        let lstKeysTemp = [];
        lstKeys.forEach(x => {
          if (this.localService.languageContent[x] == undefined)
            lstKeysTemp.push(x);
        });

        if (lstKeysTemp.length > 0) {
          this.getLanguageContentToDisplayBySection(lstKeysTemp).subscribe(result => {
            result.content.forEach(x => {
              this.localService.languageContent[x.key] = JSON.parse(x.value);
            });
            this.localService.onTriggerClass('language_content_loaded');
          });
        }
      } else if (lstKeys.length > 0) {
        this.localService.languageContent = null;
        this.getLanguageContentToDisplayBySection(lstKeys).subscribe(result => {
          this.localService.languageContent = {};
          result.content.forEach(x => {
            this.localService.languageContent[x.key] = JSON.parse(x.value);
          });
          this.localService.onTriggerClass('language_content_loaded');
        });
      }
    }
  }

  public getLanguagesToDisplay(isShowInactive: boolean = false): Observable<Languages> {
    let body = {
      sel: this.localService.getSelected(),
      dt: { v1: isShowInactive ? '1' : '0' } as KeyValues3
    };
    return this.httpService.request_general_post(this.controllerName + this.methods.GetLanguagesToDisplay, body);
  }

  public getLanguages(isShowSpinner = true): Observable<KeyValues5[]> {
    let body = {
      sel: this.localService.getSelected()
    };
    return this.httpService.request_general_post(this.controllerName + this.methods.GetLanguages, body, isShowSpinner);
  }

  public getLanguagesConfigSection(strId: string): Observable<Wrapper3> {
    let body = {
      strId: strId,
      sel: this.localService.getSelected()
    };
    return this.httpService.request_general_post(this.controllerName + this.methods.GetLanguagesConfigSection, body);
  }

  public getLanguageContentValue(strId: string, isShowSpinner = true): Observable<KeyValues3> {
    let body = {
      strId: strId
    };
    return this.httpService.request_general_post(this.controllerName + this.methods.GetLanguageContentValue, body, isShowSpinner);
  }

  public saveLanguageContent(wrapper: KeyValues3): Observable<StatusWithId> {
    let body = {
      wrapper: wrapper,
      sel: this.localService.getSelected()
    };
    return this.httpService.request_general_post(this.controllerName + this.methods.SaveLanguageContent, body);
  }

  public getLanguage(strId: string, isShowSpinner = true): Observable<Wrapper5> {
    let body = {
      strId: strId,
      sel: this.localService.getSelected()
    };
    return this.httpService.request_general_post(this.controllerName + this.methods.GetLanguage, body, isShowSpinner);
  }

  public saveLanguage(wrapper: Wrapper5): any {
    let body = {
      wrapper: wrapper,
      sel: this.localService.getSelected()
    };
    return this.httpService.request_general_post(this.controllerName + this.methods.SaveLanguage, body);
  }

  public activeInactiveStatus(strId: string, actionFor: ActiveInactiveFor): any {
    let body = {
      strId: strId,
      sel: this.localService.getSelected(),
      iActionFor: parseInt(actionFor.toString())
    };
    return this.httpService.request_general_post(this.controllerName + this.methods.ActiveInactiveStatus, body);
  }

  public saveLanguageConfigValues(wrappers: KeyValues3[]): Observable<StatusWithId[]> {
    let body = {
      wrappers: wrappers,
      sel: this.localService.getSelected()
    };
    return this.httpService.request_general_post(this.controllerName + this.methods.SaveLanguageConfigValues, body);
  }

  public saveLanguageConfigSection(wrapper: Wrapper3): Observable<StatusWithId> {
    let body = {
      wrapper: wrapper,
      sel: this.localService.getSelected()
    };
    return this.httpService.request_general_post(this.controllerName + this.methods.SaveLanguageConfigSection, body);
  }

  public getLanguageConfigSection(strParentId: string, paging: Paging, isShowSpinner = false): Observable<Wrappers3> {
    if (paging == null)
      paging = this.localService.getLastPagingSetup(GeneralConfigType.PagingLanguageSection);

    let body = {
      sel: this.localService.getSelected(),
      strParentId: strParentId,
      pag: paging
    };
    return this.httpService.request_general_post(this.controllerName + this.methods.GetLanguageConfigSection, body, (paging != null && !paging.isAutoRefresh) || isShowSpinner);
  }

  public getLanguageContentToDisplayBySection(lstKeys: string[]): Observable<DisplaySection> {
    let body = {
      sel: this.localService.getSelected(),
      lstKeys: lstKeys
    };
    return this.httpService.request_general_post(this.controllerName + this.methods.GetLanguageContentToDisplayBySection, body);
  }

  public getLanguageContainerSimple(parentId: string, languageKeyType: LanguageKeyType, languageId: string): Observable<KeyValueSet> {
    let body = {
      sel: this.localService.getSelected(),
      dt: { v1: parentId, v2: languageKeyType.toString(), v3: languageId } as KeyValues3
    };
    return this.httpService.request_general_post(this.controllerName + this.methods.GetLanguageContainerSimple, body);
  }

  public saveLanguageContainerSimple(parentId: string, languageKeyType: LanguageKeyType, languageId: string, strNewValue: string): Observable<Status> {
    let body = {
      sel: this.localService.getSelected(),
      dt: { v1: parentId, v2: languageKeyType.toString(), v3: languageId, v4: strNewValue } as KeyValues5
    };
    return this.httpService.request_general_post(this.controllerName + this.methods.SaveLanguageContainerSimple, body);
  }

  //public getLanguagesForContainer(): Observable<KeyValues3[]> {
  //  
  //  return this.httpClient.post<any>(this.languageServiceHost + this.methods.GetLanguagesForContainer, {
  //    sel: this.localService.getSelected()
  //  });
  //}

  public getMemberApplicationLanguageIdByMemberId(strUserId: string, strCtryCode: string): Observable<StatusWithId> {
    let body = {
      dt: { key: strUserId, value: strCtryCode } as KeyValueSet
    };
    return this.httpService.request_general_post(this.controllerName + this.methods.GetMemberApplicationLanguageIdByMemberId, body);
  }

  public getWords(strLanguageId: string, isOnlyMissedLanguage: boolean) {
    let body = {
      sel: this.localService.getSelected(),
      dt: { v1: strLanguageId, v2: isOnlyMissedLanguage ? '1' : '0' } as KeyValues3
    };
    return this.httpService.request_general_post_blob_response(this.controllerName + this.methods.GetWords, body, true, true);
  }

  public getLanguageContainer(strParentId: string, languageKeyType: LanguageKeyType) {
    let body = {
      sel: this.localService.getSelected(),
      dt: { v1: strParentId, v2: languageKeyType.toString() } as KeyValues3
    };
    return this.httpService.request_general_post(this.controllerName + this.methods.GetLanguageContainer, body);
  }

  public getTranslatedTextByLanguages(lstCodes: string[], strText: string, languageIdFrom: string, isTransliterate: boolean): Observable<KeyValueSet[]> {
    let body = {
      lstKeys: lstCodes,
      dt: { isSelected: isTransliterate, v1: strText, v2: languageIdFrom } as KeyValues3
    };
    return this.httpService.request_general_post(this.controllerName + this.methods.GetTranslatedTextByLanguages, body);
  }

  public refreshSearchValue(languageKeyType: LanguageKeyType, strParentId: string = "", countryCode: string = "", strBuysinessId: string = ""): Observable<Status> {
    let body = {
      sel: this.localService.getSelected(),
      dt: { v1: strParentId, v2: languageKeyType.toString(), v3: countryCode, v4: strBuysinessId } as KeyValues5
    };
    return this.httpService.request_general_post(this.controllerName + this.methods.RefreshSearchValue, body, true, false, true);
  }

  public deleteLanguage(languageId: string): Observable<StatusWithId> {
    let body = {
      sel: this.localService.getSelected(),
      dt: { v1: languageId } as KeyValues5
    };
    return this.httpService.request_general_post(this.controllerName + this.methods.DeleteLanguage, body, true, false, true);
  }

  public updateAutoTranslationBulk(languageKeyType: LanguageKeyType, strParentId: string = "", countryCode: string = "", strBusinessId: string = "", strLanguageIdToUpdate: string = ''): Observable<Status> {
    let body = {
      sel: this.localService.getSelected(),
      dt: { v1: strParentId, v2: languageKeyType.toString(), v3: countryCode, v4: strBusinessId, v5: strLanguageIdToUpdate } as KeyValues5
    };
    return this.httpService.request_general_post(this.controllerName + this.methods.UpdateAutoTranslationBulk, body, true, false, true);
  }

  public getLanguageHistories(languageKeyType: LanguageKeyType, strParentId: string = "", countryCode: string = "", strBuysinessId: string = ""): Observable<KeyValueSets[]> {
    let body = {
      sel: this.localService.getSelected(),
      dt: { v1: strParentId, v2: languageKeyType.toString(), v3: countryCode, v4: strBuysinessId } as KeyValues5
    };
    return this.httpService.request_general_post(this.controllerName + this.methods.GetLanguageHistories, body);
  }

  public getLanguagesConfigSectionByKey(strKeyParent: string, strKeyChild: string): Observable<Wrapper3> {
    let body = {
      sel: this.localService.getSelected(),
      dt: { v1: strKeyParent, v2: strKeyChild } as KeyValues3
    };
    return this.httpService.request_general_post(this.controllerName + this.methods.GetLanguagesConfigSectionByKey, body);
  }

  public refreshSearchValueBulk(languageKeyType: LanguageKeyType, countryCode?: string): Observable<Status> {
    let body = {
      sel: this.localService.getSelected(),
      dt: { v1: languageKeyType.toString(), v2: countryCode } as KeyValues3
    };
    return this.httpService.request_general_post(this.controllerName + this.methods.RefreshSearchValueBulk, body);
  }

  public correctInvalidProductNameTranslation(businessId: string): Observable<StatusWithId> {
    let body = {
      sel: this.localService.getSelected(),
      dt: { v1: businessId } as KeyValues3
    };
    return this.httpService.request_general_post(this.controllerName + this.methods.CorrectInvalidProductNameTranslation, body, true, false, true);
  }
}
